String.prototype.formataBr = function () {
  let fracao = "00";
  let numero = this.valueOf();
  numero = `${numero}`;
  if (numero.includes(".")) {
    [numero, fracao] = numero.split(".");
  }
  // Converte o número para uma string e inverte-a
  const numeroString = numero.toString().split("").reverse().join("");

  // Adiciona o ponto como separador de milhares a cada 3 dígitos
  const numeroFormatado = numeroString
    .replace(/(\d{3})/g, "$1.")
    .split("")
    .reverse()
    .join("");

  if (numeroFormatado[0].includes(".")) {
    return "" + numeroFormatado.substr(1) + "." + fracao;
  }

  // Adiciona a vírgula como separador decimal
  return "" + numeroFormatado + "." + fracao;
};

String.prototype.formataBr = function () {
  let fracao = "00";
  let numero = this.valueOf();
  numero = `${numero}`;
  if (numero.includes(".")) {
    [numero, fracao] = numero.split(".");
  }
  // Converte o número para uma string e inverte-a
  const numeroString = numero.toString().split("").reverse().join("");

  // Adiciona o ponto como separador de milhares a cada 3 dígitos
  const numeroFormatado = numeroString
    .replace(/(\d{3})/g, "$1.")
    .split("")
    .reverse()
    .join("");

  if (numeroFormatado[0].includes(".")) {
    return "" + numeroFormatado.substr(1) + "." + fracao;
  }

  // Adiciona a vírgula como separador decimal
  return "" + numeroFormatado + "." + fracao;
};

$(document).ready(function () {
  "use strict";

  let qty = $(".qtyProductDet");
  let productPrice = $("#productPrice").data("valor");
  let showPrice = $("#productPrice");
  let initialPrice = $("#productPrice").data("valor");
  let tableDesc = document.querySelectorAll(".descList");
  let totalCart = $("#cart-total");
  let selectVariable = $("#productVariable");
  const isCarrinhoPage = $(".itemCart").length > 0;

  selectVariable.on("change", function () {
    let newValue = selectVariable.val();
    let inputVar = $("#productVariable option:selected").data("titulo");

    $("#produto_variante").val(inputVar);
    $("#produto_valor").val(newValue);

    $("#productPrice").data("valor", newValue).attr("data-valor", newValue);

    productPrice = newValue;
    initialPrice = newValue;

    showPrice.html("$ " + newValue.formataBr());
  });

  const calulateDiscount = (
    qtyProd,
    price,
    firstPrice,
    printPrice,
    infoDesc,
    container
  ) => {
    let qtyVerify = 0;
    let elIndex = -1;
    qtyProd = parseInt(qtyProd);

    for (let i = 0; i < infoDesc.length; i++) {
      const element = parseInt(infoDesc[i].dataset.qty);

      if (qtyProd >= element) {
        if (element > qtyVerify) {
          qtyVerify = element;
          elIndex = i;
        }
      }
    }

    if (elIndex != -1) {
      // Multiplica o valor do produto pela quantidade
      price = firstPrice * qtyProd;

      let decimalDesc = parseFloat(infoDesc[elIndex].dataset.desc / 100);

      applyDiscount(price, decimalDesc, printPrice, container);

      // Somente na página do carrinho, mostra o texto do desconto
      if (isCarrinhoPage) {
        const currentDiscountSpan = printPrice
          .closest(".itemCart")
          .find(".current-discount");

        if (currentDiscountSpan.length > 0) {
          let percent = parseFloat(infoDesc[elIndex].dataset.desc);
          currentDiscountSpan.css("display", "inline-block");
          currentDiscountSpan.text(`Current discount is ${percent}%`);
        }
      }
    } else {
      price = firstPrice * qtyProd;

      // Sem desconto
      printPrice.html(`$ ${price.toFixed(2).formataBr()}`);
      printPrice.data("subtotal", price.toFixed(2));
      printPrice.attr("data-subtotal", price.toFixed(2));

      if (container != undefined) {
        container.find('input[name="produto_subtotal"]').val(price.toFixed(2));
      }

      if (isCarrinhoPage) {
        const currentDiscountSpan = printPrice
          .closest(".itemCart")
          .find(".current-discount");
        if (currentDiscountSpan.length > 0) {
          currentDiscountSpan.css("display", "none");
        }
      }
    }
  };

  // aplica o desconto
  const applyDiscount = (priceP, discount, printP, container) => {
    priceP = parseFloat(priceP);
    discount = parseFloat(discount);

    let desc = priceP * discount;
    let price = priceP - desc;

    printP.html(`$ ${price.toFixed(2).formataBr()}`);
    printP.data("subtotal", price.toFixed(2));
    printP.attr("data-subtotal", price.toFixed(2));

    //console.log(container);

    if (container != undefined) {
      container.find('input[name="produto_subtotal"]').val(price.toFixed(2));
    }
  };

  // Verifica se o campo de quantidade já tem valor (Página de Detalhe)
  calulateDiscount(
    qty.val(),
    productPrice,
    initialPrice,
    showPrice,
    tableDesc,
    $("#form-add-cart")
  );

  // Altera o valor do desconto quando o campo de quantidade é alterado (Página de Detalhe)
  qty.on("change", function () {
    calulateDiscount(
      qty.val(),
      productPrice,
      initialPrice,
      showPrice,
      tableDesc,
      $("#form-add-cart")
    );

    // if ($("#cupom").data("cupom") != "") {
    //   cupomCart();
    // }
  });

  // Altera o valor do desconto quando o campo de quantidade é alterado (Carrinho)
  $(document).on("change", ".qtyProduct", function () {
    let $input = $(this);
    let quantidade = parseInt($input.val()) || 0;

    // Pega a linha (tr) do item atual
    let $linha = $input.closest(".itemCart");

    // Valor unitário do produto
    let valor = $linha.data("valor");

    let idProd = $linha.data("row");

    let itemPrice = $linha.find(".cart-subtotal");

    let descInfo = $linha.find(".descList");

    calulateDiscount(quantidade, valor, valor, itemPrice, descInfo);
    updateQtdeCart(idProd, quantidade); // TROCAR DEPOIS

    let total = 0;
    // Atualiza total
    $(".itemCart").each(function () {
      let $el = $(this);

      let subtotal = parseFloat($el.find(".cart-subtotal").data("subtotal"));

      // Remove o símbolo "$" e converte para número
      //let subtotal = parseFloat(elItemPrice.replace("$", "").trim());

      if (!isNaN(subtotal)) {
        total += subtotal;
      }
    });
    totalCart
      .data("valortotal", total.toFixed(2))
      .attr("data-valortotal", total.toFixed(2));
    totalCart.html("$ " + total.toFixed(2).formataBr());

    montarResumoPedido();
  });

  // Se estiver na página do carrinho
  if (isCarrinhoPage) {
    montarResumoPedido();
    $(".itemCart").each(function () {
      const $linha = $(this);
      const quantidade = parseInt($linha.find(".qtyProduct").val()) || 0;
      const valor = parseFloat($linha.data("valor"));
      const itemPrice = $linha.find(".cart-subtotal");
      const descInfo = $linha.find(".descList");

      calulateDiscount(quantidade, valor, valor, itemPrice, descInfo);
    });

    // Atualiza o total geral ao carregar
    let total = 0;
    $(".itemCart").each(function () {
      let subtotal = parseFloat(
        $(this).find(".cart-subtotal").data("subtotal")
      );
      if (!isNaN(subtotal)) total += subtotal;
    });
    $("#cart-total")
      .data("valortotal", total.toFixed(2))
      .attr("data-valortotal", total.toFixed(2));
    $("#cart-total").html("$ " + total.toFixed(2).formataBr());
  }

  function montarResumoPedido() {
    let itens = [];
    let totalGeral = 0;

    $(".itemCart").each(function () {
      let $el = $(this);

      let nome = $el.find("td:eq(1) b").text().trim();
      let quantidade = parseInt($el.find(".qtyProduct").val()) || 0;

      let subtotalAttr = $el.find(".cart-subtotal").attr("data-subtotal");
      let subtotal = parseFloat(subtotalAttr) || 0;

      // Desconto (se quiser mostrar no PHP)
      let desconto = parseFloat($el.find(".descList").data("desc")) || 0;

      // Validação: ignora item inválido
      if (!nome || quantidade <= 0 || subtotal <= 0) return;

      totalGeral += subtotal;

      itens.push({
        nome: nome,
        quantidade: quantidade,
        desconto: desconto + "%",
        subtotal: subtotal.toFixed(2),
      });
    });

    // Pega o desconto do cupom
    let cupomDescText = $("#descValue").text().trim();

    // Converte para número
    // if (cupomDescText) {
    //   // Remove tudo que não é número
    //   let numText = cupomDescText.replace(/[^\d.,-]/g, "").replace(",", ".");
    //   descontoCupom = parseFloat(numText);
    //   if (isNaN(descontoCupom)) descontoCupom = 0;
    // }

    let descontoCupom = 0;
    let match = cupomDescText.match(/-?\d+(\.\d+)?/);
    if (match) descontoCupom = parseFloat(match[0].replace(",", "."));

    // Calcula total final subtraindo desconto do cupom
    totalGeral = totalGeral - descontoCupom;

    // Pega o texto do cupom aplicado
    let cupomTag = $("#cupomTag").text().trim();

    let resumo = {
      itens: itens,
      total: totalGeral.toFixed(2),
      cupom: cupomTag,
      cupomDescPrice: descontoCupom.toFixed(2),
    };

    console.log(resumo);

    // Envia para input hidden
    $("#resumoPedido").val(JSON.stringify(resumo));
  }

  const urlAction = url_base + "acoes/app/produtos/carrinho.php";

  // Atualiza a quantidade do produto do carrinho
  function updateQtdeCart(idItem, itemQtde) {
    $.ajax({
      url: urlAction,
      type: "POST",
      data: {
        registro_id: idItem,
        quantidade: itemQtde,
        acao: "update",
      },
      beforeSend: function () {
        showLoading();
      },
      success: function (data) {
        //console.log(data);
        hideLoading();
        if (data == "ok") {
          // updateCart();
        } else {
          showAlert("Error", "This operation could not be performed.", "error");
        }
      },
      error: function (xhr, type, exception) {
        hideLoading();
        showAlert("Error", "This operation could not be performed.", "error");
      },
    });
  }

  // Evento do botão para aplicar cupom de desconto
  $("#formCarrinhoCupom").on("submit", function (e) {
    e.preventDefault();
    cupomCart();
  });

  // Aplica cupom de desconto no carrinho
  function cupomCart() {
    let code = $("#cupom").val();
    let totalCart = $("#cart-total").data("valortotal");

    $.ajax({
      url: urlAction,
      type: "POST",
      data: {
        cupom: code,
        total: totalCart,
        acao: "cupom",
      },
      dataType: "json",
      beforeSend: function () {
        showLoading();
      },
      success: function (data) {
        //console.log(data);
        if (data.sucesso) {
          hideLoading();
          showAlert("Success", data.mensagem, "success");

          // Se quiser aplicar desconto visualmente no carrinho:
          if (data.desconto) {
            const codeName = $("#cupom");
            codeName.data("cupom", code).attr("data-cupom", code);

            $("#cupomTag").css("display", "inline-block");
            $("#cupomTag").text("Coupon applied: " + data.titulo);

            parseFloat(totalCart);
            const desconto = parseFloat(data.desconto);
            const novoTotal = totalCart - totalCart * (desconto / 100);

            let valueDesc = totalCart * (desconto / 100);
            $("#descValue").html("- $ " + valueDesc.toFixed(2).formataBr());

            $("#cart-total")
              .html("$ " + novoTotal.toFixed(2).formataBr())
              .data("valor", novoTotal.toFixed(2));

            codeName.val("");
            montarResumoPedido();
          }
        } else {
          hideLoading();
          showAlert("Error", data.mensagem, "error");
        }
      },
      error: function (xhr, type, exception) {
        hideLoading();
        showAlert("Error", "This operation could not be performed.", "error");
      },
    });
  }
});
